import React from "react";
import { Drawer } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import BarCodeGroupedHandler from "../../../lib/BarcodeGroupedHandler";
import IntegratedWeightModal from "../../../lib/components/IntegratedWeightModal";
import ProductSelector from "./ProductSelector";
import MixSummary from "./MixSummary";
import useCustomMix from "./useCustomMix";
import usePOSConfigStore from "../../../stores/usePOSConfigStore";
import "./CustomMix.css";

const CustomMixModal = ({
  showCustomMix,
  setShowCustomMix,
  cart,
  setCart,
  customMixItems,
  setCustomMixItems,
  groupName,
  setGroupName,
  groupQty,
  setGroupQty,
  existingGroupItems,
  setExistingGroupItems,
  selectedCustomMix,
  setSelectedCustomMix,
  orderType,
  setOrderType,
  posSaleTypes,
  setPosSaleTypes,
  currenciesData,
  setCurrenciesData,
  searchInputRef,
  setProductStock,
  setShowCompleteSaleStock,
  setCompleteSaleStockData,
  processBillDiscounts,
  setLoader,
  processTotalManualDiscount,
}) => {
  const posConfig = usePOSConfigStore((s) => s.posConfig);

  const {
    searchQuery,
    setSearchQuery,
    currentPage,
    setCurrentPage,
    submitting,
    paginatedData,
    totalPages,
    precision,
    handlePreviousPage,
    handleNextPage,
    handleIncrease,
    handleDecrease,
    handleDelete,
    handleQuantityChange,
    handleGroupQtyChange,
    handleSubmit: submitMix,
    resetState,
    shouldOpenWeightPopup,
    openWeightPopupForGrouped,
    stockFailedItems,
    // Integrated weight popup (ProductsPopup-style, non-alternate UOM)
    integratedWeightProduct,
    integratedWeightPopupOpen,
    integratedWeightInputRef,
    handleIntegratedWeightTotalQty,
    handleIntegratedWeightInputChange,
    handleIntegratedWeightConfirm,
    handleIntegratedWeightCancel,
  } = useCustomMix({
    cart,
    setCart,
    customMixItems,
    setCustomMixItems,
    groupName,
    setGroupName,
    groupQty,
    setGroupQty,
    existingGroupItems,
    setExistingGroupItems,
    selectedCustomMix,
    setSelectedCustomMix,
    orderType,
    setOrderType,
    posSaleTypes,
    setPosSaleTypes,
    currenciesData,
    setCurrenciesData,
    setProductStock,
    setShowCompleteSaleStock,
    setCompleteSaleStockData,
    processBillDiscounts,
    setLoader,
    processTotalManualDiscount,
  });

  const handleClose = () => {
    setShowCustomMix(false);
    resetState();
    setTimeout(() => {
      if (searchInputRef?.current) searchInputRef.current.focus();
    }, 300);
  };

  const handleSubmit = async () => {
    const success = await submitMix();
    if (success) {
      setShowCustomMix(false);
      resetState();
      setTimeout(() => {
        if (searchInputRef?.current) searchInputRef.current.focus();
      }, 300);
    }
  };

  return (
    <>
    <Drawer
      open={showCustomMix}
      placement="right"
      width="75vw"
      closable={true}
      closeIcon={<CloseOutlined style={{ color: "#2F3856", fontSize: "16px" }} />}
      onClose={handleClose}
      title={<span style={{ color: "#000" }}>Custom Mix</span>} 
      className="custom-mix-drawer"
      maskClosable={false}
      destroyOnClose
      headerStyle={{ background: "#fff" }}
    >
      <BarCodeGroupedHandler
        setCustomMixItems={setCustomMixItems}
        cart={cart}
        setCart={setCart}
        setProductStock={setProductStock}
        setShowCompleteSaleStock={setShowCompleteSaleStock}
        setCompleteSaleStockData={setCompleteSaleStockData}
      />

      <div className="cm-product-panel">
        <ProductSelector
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          setCurrentPage={setCurrentPage}
          paginatedData={paginatedData}
          customMixItems={customMixItems}
          currentPage={currentPage}
          totalPages={totalPages}
          handlePreviousPage={handlePreviousPage}
          handleNextPage={handleNextPage}
          handleIncrease={handleIncrease}
          handleDecrease={handleDecrease}
          handleQuantityChange={handleQuantityChange}
          shouldOpenWeightPopup={shouldOpenWeightPopup}
          openWeightPopupForGrouped={openWeightPopupForGrouped}
        />
      </div>

      <div className="cm-summary-panel">
        <MixSummary
          customMixItems={customMixItems}
          groupName={groupName}
          setGroupName={setGroupName}
          groupQty={groupQty}
          handleGroupQtyChange={handleGroupQtyChange}
          handleQuantityChange={handleQuantityChange}
          handleDelete={handleDelete}
          handleSubmit={handleSubmit}
          submitting={submitting}
          precision={precision}
          shouldOpenWeightPopup={shouldOpenWeightPopup}
          openWeightPopupForGrouped={openWeightPopupForGrouped}
          stockFailedItems={stockFailedItems}
        />
      </div>
    </Drawer>
    {/* Integrated weight popup -- for products WITHOUT alternate UOM (ProductsPopup-style) */}
    <IntegratedWeightModal
      open={integratedWeightPopupOpen && !(integratedWeightProduct?.alternateUom?.length > 0 && integratedWeightProduct?.showAlternateUomInPos === "Y")}
      product={integratedWeightProduct}
      onTotalQty={handleIntegratedWeightTotalQty}
      onInputChange={handleIntegratedWeightInputChange}
      onConfirm={handleIntegratedWeightConfirm}
      onCancel={handleIntegratedWeightCancel}
      inputRef={integratedWeightInputRef}
      strictQty={posConfig?.requireQtyBeforeAddingItem === "Y"}
    />
    </>
  );
};

export default CustomMixModal;
